import React, { Component } from 'react';

import Loading from '@qality/common-components/src/atoms/Loading/Loading';
import { StorageOfUniqueServices } from '@qality/common-service';

type Props = {
  children: React.ReactChild;
};

type State = {
  projectsAvailabilityByProjectKey: {
    [key: string]: { isPluginEnabled: boolean };
  } | null;
};

export const ProjectsAvailabilityContext: React.Context<{
  projectsAvailabilityByProjectKey?: {
    [key: string]: { isPluginEnabled: boolean };
  } | null;
}> = React.createContext({});

export class ProjectsAvailabilityContextProvider extends Component<
  Props,
  State
> {
  state = { projectsAvailabilityByProjectKey: null };

  async componentDidMount(): Promise<void> {
    this.setState({
      projectsAvailabilityByProjectKey: await StorageOfUniqueServices.get(
        'SettingServiceUnique'
      ).getProjectsAvailabilityByProjectKey(),
    });
  }

  render(): React.ReactNode {
    const { children } = this.props;

    if (this.state.projectsAvailabilityByProjectKey === null) {
      return <Loading />;
    }
    return (
      <ProjectsAvailabilityContext.Provider
        value={{
          projectsAvailabilityByProjectKey:
            this.state.projectsAvailabilityByProjectKey,
        }}
      >
        {children}
      </ProjectsAvailabilityContext.Provider>
    );
  }
}

export const ProjectsAvailabilityContextConsumer =
  ProjectsAvailabilityContext.Consumer;
